import { render, staticRenderFns } from "./BuildWrapperBlock.vue?vue&type=template&id=5d510e5e&scoped=true&"
import script from "./BuildWrapperBlock.vue?vue&type=script&lang=js&"
export * from "./BuildWrapperBlock.vue?vue&type=script&lang=js&"
import style0 from "./BuildWrapperBlock.vue?vue&type=style&index=0&id=5d510e5e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d510e5e",
  null
  
)

export default component.exports